var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAsesorarte(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.8333 49.9997C82.3392 49.9997 91.6667 40.6723 91.6667 29.1663C91.6667 17.6604 82.3392 8.33301 70.8333 8.33301C59.3275 8.33301 50 17.6604 50 29.1663C50 32.499 50.7825 35.6489 52.1737 38.4423C52.5437 39.1847 52.6667 40.0331 52.4525 40.8343L51.2117 45.4718C50.6729 47.4851 52.5146 49.3268 54.5279 48.788L59.1654 47.5472C59.9667 47.333 60.815 47.4559 61.5575 47.8259C64.3508 49.2172 67.5008 49.9997 70.8333 49.9997Z",
    stroke: "#1C274C",
    strokeWidth: 3.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3608 41.3879C8.05938 49.3383 10.0715 62.8404 23.6156 76.3846C26.8831 79.6521 30.1482 82.2483 33.3335 84.3029M14.741 28.9051C20.545 23.1012 29.805 23.881 33.4901 30.484L36.1943 35.3296C38.6348 39.7024 37.6551 45.4387 33.8115 49.2825C33.8115 49.2825 29.1497 53.945 37.6023 62.3979C46.0523 70.8479 50.7177 66.1887 50.7177 66.1887C54.5614 62.345 60.2977 61.3654 64.6706 63.8058L69.516 66.51C76.1193 70.195 76.8989 79.455 71.0952 85.2592C67.6077 88.7467 63.3352 91.4604 58.6123 91.6392C55.2206 91.7679 50.8181 91.4754 45.8335 90.0462",
    stroke: "#1C274C",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAsesorarte);
export default __webpack_public_path__ + "static/media/ic_asesorarte.31b407ef43487fb21ca78ab5d72c3fc1.svg";
export { ForwardRef as ReactComponent };